import "./SingleProduct.scss";
import { useState, useEffect, useContext } from "react";
import React from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  TrashIcon,
  AddIcon,
  MinesIcon,
} from "../kits/Icons/Icons.tsx";
import CustomButton from "../kits/custom-button/CustomButton.tsx";
import SnackBar from "../kits/SnackBar";
import CartItemBtn from "../cartitem/CartitemBtn.jsx";
import ColorSchema from "../../assets/kits/colors";

import { addCommas } from "@persian-tools/persian-tools";
import { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { NavLink } from "react-router-dom";
import gv from "../../assets/kits/global-variables.module.scss";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext.tsx";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import CloseDrawer from "../ShopPage/CloseDrawer/CloseDrawer.jsx";
import { pathMaker } from "../../utilities/helperFunctions";
import defaultCover from "../../assets/images/defaultCover/defaultCoverProduct.png";
import Image from "../common/Image.tsx";

import EditSingleProduct from "./EditSingleProduct";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import DrawerTxtTwoBtn from "./DrawerTxtTwoBtn";

import CartItemSection from "../common/ProductCard/CartItemSection.tsx";
import BoxSlider from "../common/slider/BoxSlider";
import { getBoxByPosition } from "../../utilities/apiTools";
import { useAnalyticsEventTracker } from "../../utilities/helperFunctions";
import newLogo from "../../assets/images/logo/sabadiLogo.png";
// import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
// import { useOverlayScrollbars } from "overlayscrollbars-react";
// import "overlayscrollbars/overlayscrollbars.css";
export default function SingleProduct({
  product,
  shopId,
  productId,
  onLoad,
  updater1,
  setUpdater1,
}) {
  // const EventTracker = useAnalyticsEventTracker("test", "click", "store name");
  const auth = useContext(AuthenticationContext);
  const idUserLogin = auth?.userInfo?.id;
  const adminShop = product?.supplier?.main_admin_uid;
  const isSuperAdmin = auth?.userInfo?.access_level?.isSuperAdmin;
  const [inactiveDrawer, setInactiveDrawer] = useState(false);
  console.log(product);
  const {
    getItemCountPerShop,
    changeShoppingCartItemCount,
    getItemsShop,
    shoppingListItemsFinalState,
  } = useContext(ShoppingCartItemContext);
  const finalState = shoppingListItemsFinalState;
  const [loadImg, setLoadImg] = useState(true);
  const winSize = useWindowSize();
  const count = getItemCountPerShop(shopId)[`apoId_${productId}`];
  const [editModalShow, setEditModalShow] = useState(false);
  const [isOpenBtn, setIsOpenBtn] = useState(false);
  const [closeDrawer, setCloseDrawer] = useState(false);
  const [shopStatus, setShopStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  let nowHour = new Date().getHours();
  let nowMin = new Date().getMinutes();
  useEffect(() => {
    let start_hour = product?.supplier.start_hour;
    let finish_hour = product?.supplier.finish_hour;
    let start_min = product?.supplier.start_min;
    let finish_min = product?.supplier.finish_min;
    if (
      nowHour < start_hour ||
      nowHour > finish_hour ||
      (nowHour == start_hour && nowMin < start_min) ||
      (nowHour == finish_hour && nowMin > finish_min) ||
      product?.supplier.main_status != "0"
    ) {
      setShopStatus(false);
    }
  }, []);

  const addOne = () => {
    changeShoppingCartItemCount(
      "add",
      " ",
      product.avb_product.total_inventory_count,
      product.avb_product.min_order_count,
      getItemCountPerShop(shopId)[`apoId_${productId}`],
      "1",
      product.price,
      productId,

      product.title,
      shopId
    );
  };
  const decreaseOne = () => {
    changeShoppingCartItemCount(
      "reduce",
      " ",
      product.avb_product.total_inventory_count,
      product.avb_product.min_order_count,
      getItemCountPerShop(shopId)[`apoId_${productId}`],
      "1",
      product.price,
      productId,

      product.title
    );
  };

  const [boxBanners, setBoxBanners] = useState({});
  useEffect(() => {
    const loadBanner = async () =>
      setBoxBanners(await getBoxByPosition("h21,h22"));
    loadBanner();
  }, []);

  return (
    <div className="position-relative d-flex flex-column h-100">
      <div className="position-relative">
        <div
          className="position-absolute mr-t-12 mr-r-20 "
          style={{ zIndex: "2", cursor: "pointer" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <ArrowRightIcon />
        </div>

        {boxBanners.h21 && (
          <div className="mr-b-12 pd-x-12">
            <BoxSlider banner={boxBanners.h21} />
          </div>
        )}
        <Swiper
          dir="rtl"
          modules={[Pagination]}
          pagination={true}
          slidesPerView={1}
        >
          <SwiperSlide>
            <Image
              src={pathMaker(product?.cover1)}
              style={{ width: "100%", height: "370px" }}
              placeholderSrc={newLogo}
            />
            {/* <img
              src={loadImg ? defaultCover : pathMaker(product?.cover1)}
              // src={defaultCover}
              // alt={defaultCover}
              onLoad={e => {
                setLoadImg(false);
                onLoad(e);
              }}
              height="370"
              width="100%"
            /> */}
          </SwiperSlide>
          {product?.cover2 != null && (
            <SwiperSlide>
              <Image
                src={pathMaker(product?.cover2)}
                style={{ width: "100%", height: "370px" }}
                placeholderSrc={newLogo}
              />
              {/* <img
                src={loadImg ? defaultCover : pathMaker(product?.cover2)}
                onLoad={e => {
                  setLoadImg(false);
                  onLoad?.(e);
                }}
                height="370"
                width="100%"
              /> */}
            </SwiperSlide>
          )}
        </Swiper>
      </div>
      {boxBanners.h22 && (
        <div className="mr-b-12 pd-x-12">
          <BoxSlider banner={boxBanners.h22} />
        </div>
      )}
      <div className="d-flex justify-content-between pd-r-20 pd-l-16 mr-t-16">
        <NavLink
          to={`/shop/${shopId}`}
          style={{
            textDecoration: "none",
            color: ColorSchema.foreground_background_he,
          }}
        >
          <div className="desc-m">{product?.supplier?.title}</div>
        </NavLink>
        <NavLink
          to={`/category/${shopId}/${product?.line_id}`}
          className="product-category"
        >
          <div className="d-flex" style={{ cursor: "pointer" }}>
            <span className="desc-l category-title">{product?.line_title}</span>
            <ArrowLeftIcon width="16px" height="16px" />
          </div>
        </NavLink>
      </div>
      <hr className="line mr-y-16" />
      <div className="d-flex justify-content-between align-items-start  mr-x-20">
        <div
          className="product-title title-h4-m"
          style={{
            color: ColorSchema.foreground_background_he,
            maxHeight: 48,
          }}
          // onClick={() => {
          //   console.log(" test&*");
          //   EventTracker();
          // }}
        >
          {product?.title}
        </div>
      </div>
      {product?.description != "" && (
        <p
          className="product-desc desc-c-l mr-x-20 mr-t-12"
          style={{ maxHeight: 63 }}
        >
          {product?.description}
        </p>
      )}
      <hr className="line mr-y-16" />
      <div className="d-flex justify-content-between">
        <div className="mr-r-20">
          <div
            className="desc-m"
            style={{ color: ColorSchema.foreground_background_me }}
          >
            قیمت نهایی
          </div>
          {product?.avb_product?.discount == "0" ? (
            <div
              className="title-h5-m mr-t-4"
              style={{ color: ColorSchema.foreground_background_he }}
            >
              {addCommas(product?.price)} تومان
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <div
                className="d-flex desc-m pd-x-4 mr-t-6"
                style={{
                  backgroundColor: ColorSchema.schema_primary_main,
                  color: ColorSchema.white_0,
                  height: "14px",
                  borderRadius: "23px",
                  whiteSpace: "nowrap",
                }}
              >
                {Math.round(
                  (product?.avb_product.discount / product?.price) * 100
                )}
                &nbsp;%
              </div>
              <div
                className="desc-m mr-t-4 text-decoration-line-through mr-x-4"
                style={{ color: ColorSchema.foreground_background_me }}
              >
                {addCommas(product?.price)} تومان
              </div>
              <div
                className="title-h5-m mr-t-4"
                style={{ color: ColorSchema.foreground_background_he }}
              >
                {addCommas(product?.price - product?.avb_product.discount)}{" "}
                تومان
              </div>
            </div>
          )}
        </div>

        {count == undefined ? (
          <div className="mr-l-20">
            {finalState[`state-${productId}`] == false ||
            finalState[`state-${productId}`] == undefined ? (
              <CustomButton
                buttonStyle="secondary"
                size="medium"
                state={shopStatus ? "default" : "disable"}
                onClick={async () => {
                  await addOne();

                  setIsOpenBtn(true);
                }}
                disabledOnClick={() => {
                  setCloseDrawer(true);
                }}
              >
                افزودن
              </CustomButton>
            ) : (
              <CustomButton
                className="pd-0 mr-0"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                state="loading"
              />
            )}
            <CloseDrawer
              isOpen={closeDrawer}
              setIsOpen={setCloseDrawer}
              shopName={product?.supplier.title}
            ></CloseDrawer>
          </div>
        ) : (
          <div className="mr-l-16">
            <CartItemSection
              disabled={!shopStatus}
              cartItemCount={getItemCountPerShop(shopId)[`apoId_${productId}`]}
              loading={finalState[`state-${productId}`] == true ? true : false}
              plusOnClick={addOne}
              minusOnClick={decreaseOne}
              style={{ border: "none" }}
              disabledOnClick={() => {
                setCloseDrawer(true);
              }}
            ></CartItemSection>
          </div>
          // <div className="d-flex align-items-baseline mr-l-4">
          //   <CustomButton
          //     buttonStyle="secondary border-none"
          //     size="medium"
          //     onClick={() => {
          //       addOne();
          //     }}
          //   >
          //     <AddIcon color={ColorSchema.schema_primary_main} />
          //   </CustomButton>
          //   <span className="title-h5-m ">{count}</span>
          //   {count == 1 && (
          //     <CustomButton
          //       buttonStyle="secondary border-none"
          //       size="medium"
          //       onClick={() => {
          //         decreaseOne();
          //       }}
          //     >
          //       <TrashIcon />
          //     </CustomButton>
          //   )}
          //   {count > 1 && (
          //     <CustomButton
          //       buttonStyle="secondary border-none"
          //       size="medium"
          //       onClick={decreaseOne}
          //     >
          //       <MinesIcon
          //         style={{ color: ColorSchema.foreground_background_me }}
          //       />
          //     </CustomButton>
          //   )}
          // </div>
        )}
      </div>
      {(isSuperAdmin || idUserLogin == adminShop) && (
        <div className="mr-t-auto mr-b-8 pd-t-4  mr-x-20 d-flex justify-content-end ">
          <div className="w-100">
            {" "}
            <EditSingleProduct
              show={editModalShow}
              product={product}
              setShow={setEditModalShow}
              updater1={updater1}
              setUpdater1={setUpdater1}
            />
          </div>
          {/* <CustomButton className="w-50"
                buttonStyle="text"
                size="medium"
                state={shopStatus ? "default" : "disable"}
                onClick={async () => {
                  setInactiveDrawer(true)
                }}
                disabledOnClick={() => {
                }}
              >
                غیرفعال
              </CustomButton> */}
        </div>
      )}
      {/* <DrawerTxtTwoBtn
          isOpen={inactiveDrawer}
          setIsOpen={setInactiveDrawer}
          height={140}
          mainText="آیا از غیرفعال کردن محصول مطمئن هستید؟"
          btnText="غیرفعال"
        /> */}
      {count >= 1 && (
        <div style={{ marginTop: 60 }}>
          <div
            className=" mr-x-auto pd-x-20"
            style={{
              width: winSize.width < 600 ? "100%" : "600px",
              position: "fixed",
              bottom: 84,
              zIndex: 1000,
            }}
          >
            <NavLink
              to={`/shop/${shopId}`}
              style={{
                textDecoration: "none",
                width: "100%",
              }}
            >
              <SnackBar
                className="txt-t2-l text-decoration-none"
                style={{ height: 48 }}
                text={`ادامه خرید از ${product?.supplier.title}`}
                color={ColorSchema.schema_primary_main}
                backgroundColor={ColorSchema.schema_primary_light}
                borderColor={ColorSchema.schema_primary_main}
                button
                buttonContent={
                  <ArrowLeftIcon color={ColorSchema.schema_primary_main} />
                }
              />
            </NavLink>
          </div>
        </div>
      )}
      {(count >= 1 || getItemsShop(shopId).items?.length > 0) && (
        <div style={{ paddingBottom: 72 }}>
          <CartItemBtn isOpen2={true} height={72} shopId={shopId} />
        </div>
      )}
    </div>
  );
}
